<div id="popup" class="main-container popup" (click)="$event.stopPropagation()">
  <ul class="tabs flex-row">
    <li class="tabs__item" [ngClass]="{active: isProfileTabActive}" (click)="showContentOf('profile', $event)">
      <span class="tabs__item--text">{{'profile' | translate}}</span>
    </li>
    @if (!isOktaLogin) {
      <li class="tabs__item" [ngClass]="{active: !isProfileTabActive && !isDeactivateTabActive && !isUpdateEmailTab}" (click)="showContentOf('password', $event)">
        <span class="tabs__item--text">{{'reset_password' | translate}}</span>
      </li>
    }
    @if (isAdminUser) {
      <li class="tabs__item" [ngClass]="{active: !isProfileTabActive && isDeactivateTabActive}" (click)="showContentOf('deactivate', $event)">
        <span class="tabs__item--text">{{'deactivate_account' | translate}}</span>
      </li>
    }
    @if (isSolenisMigrationEmail && !checkDiverseyRootOrPowerAdmin()) {
      <li class="tabs__item" [ngClass]="{active: !isProfileTabActive && !isDeactivateTabActive && isUpdateEmailTab}" (click)="showContentOf('updateEmail', $event)">
        <span class="tabs__item--text"> Update Email </span>
      </li>
    }
  </ul>
  <div class="popup-body-container">
    <ng-content></ng-content>
    <span class="popup-collapse" (click)="collapse()">
      <i class="fa fa-compress" aria-hidden="true"></i>
    </span>
  </div>
</div>
